export { default } from './PageAttribute.vue'
